import React from "react";
import { Locale } from "@linkfluence/models/locale";
import Button from "@ui-kit/button";
import Menu from "@ui-kit/popover/menu";
import { useFeature } from "@radarly/core/features/use-cases";
import { tr } from "@radarly/i18n";
import { Post, PostLensFactory } from "@radarly/models/posts";

interface IDButtonProps {
  post: Post;
  handleSelect: (id: PostMenuAction) => void;
  locale: Locale;
}

export type PostMenuAction = "copy_post_id" | "copy_author_id";

export default function PostMenu({
  post,
  handleSelect,
  locale,
}: IDButtonProps) {
  const isPinnedAuthorEnabled = useFeature("pinned_author");
  const lens = PostLensFactory.create(post);
  const menuValues: { id: PostMenuAction; label: string }[] = [];

  menuValues.push({
    id: "copy_post_id",
    label: tr(locale, "INSIGHT_PAGES_POST_ID_COPY_LABEL"),
  });

  if (isPinnedAuthorEnabled && lens.getInfluencerUid()) {
    menuValues.push({
      id: "copy_author_id",
      label: tr(locale, "INSIGHT_PAGES_AUTHOR_ID_COPY_LABEL"),
    });
  }

  return (
    <Menu
      values={menuValues}
      onSelect={(id: PostMenuAction) => handleSelect(id)}
      disclosure={<Button size="xs" icon="dots-3-v" variant="tertiary" />}
    />
  );
}
